import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type GtmStateType = {
    events: Record<string, boolean>;
    onChange: (key: string, value: boolean) => void;
    clear: () => void;
}


export const useGtmState = create(
  persist<GtmStateType>(
    (set, get) => ({
        events: {},
        onChange: (key, value) => set({ events: {...get().events, [key]: value} }),
        clear: () => set({events: {}}),
    }),
    {
      name: "gtmTriggerGroup",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
